import React, { useEffect, useState, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import clsx from "clsx";
import {
    Button,
    Form,
  } from "react-bootstrap";
  
import "./addGrille.css";

const CriteriaValue = (props) => {
  let valeurAtt = props.value

  return (
    <>

          <div key={valeurAtt.idCriteriaValue} style={{marginBottom:5, marginRight:' -60px'}}>
          <Form.Control
                  data-color={valeurAtt.color}
                  className="container-input-values borderColor"
                  style={{
                    fontFamily:"Gilroy-regular",
                    fontWeight:500,
                    fontSize:12,
                    color: "rgb(183, 183, 183)",
                    backgroundColor:
                    `${valeurAtt?.color}20` || "rgba(183, 183, 183, 0.1)",
                    top: props.valuesNumber > 2 ? 15 : 3,

                  }}
                  type="text"
                  key={valeurAtt.id}
                  placeholder={`Valeur numéro ${valeurAtt.id}`}
                  defaultValue={valeurAtt.name ==='' ? '' : valeurAtt.name}
                  tabIndex="0"
                  onChange={(e) => {
                    valeurAtt.name = e.target.value;
                    props.handelChangeCriteriaValue(valeurAtt, props.idGroupCriteria, props.idCriteria, valeurAtt.id);
                  }}
                  onClick={()=> props.selectValue(valeurAtt)}
              
                />

          <div
            className="btn-inside-remove"
          >
           {
             props.valuesNumber > 2 ?
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 33.941 33.941" onClick={()=> props.removeClick(valeurAtt.id)}>
              <g id="add-circle-outline-round-24px" transform="translate(0 16.971) rotate(-45)">
                <path  style={{fill:(valeurAtt.color !=='none' ? valeurAtt.color : 'rgb(183, 183, 183) '),}} id="Tracé_14875" data-name="Tracé 14875" d="M12,7a1,1,0,0,0-1,1v3H8a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V13h3a1,1,0,0,0,0-2H13V8A1,1,0,0,0,12,7Zm0-5A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.011,8.011,0,0,1,12,20Z" fill="#1ca91b" stroke="#e7f6e7" stroke-width="0.5"/>
              </g>
            </svg>
           : null
           }

          </div>
        </div>     
    </>
  );
};

export default CriteriaValue;
